module.exports = __webpack_public_path__ + "static/media/raiarBlue.139d6e61.png";